import React, {useState, useEffect, useCallback, useRef} from 'react';
import {Select as AntSelect} from "antd";
import styled from "styled-components";
import api from "../../services/api";

const StyledAntSelect = styled(AntSelect)`
    height: min-content;

    .ant-select-selection-item {
        white-space: wrap;
    }

    .ant-select-selection-overflow {
        gap: 4px;
    }
    max-width: inherit;
`

//todo select chamando varias vezes
export default function Select({request, options: externalOptions, showSearch = true, ...props}) {
    const isRequest = !!request;

    const [fetchedOptions, setFetchedOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [search, setSearch] = useState('');
    const [nextPage, setNextPage] = useState(null);
    const currentSearchRef = useRef('');

    const {
        url,
        params: requestParams,
        labelField = 'name',
        valueField = 'id',
        paginated = true,
    } = request || {};

    const mapItems = useCallback((items) => {
        return items.map((item) => ({
            label: item[labelField],
            value: item[valueField],
            object: item,
        }));
    }, [labelField, valueField]);

    const fetchData = useCallback(async (searchValue, pageUrl) => {
        if (!url) return;
        const isNextPage = !!pageUrl;
        if (isNextPage) {
            setLoadingMore(true);
        } else {
            setLoading(true);
        }
        try {
            const requestUrl = pageUrl || url;
            const params = pageUrl ? {} : {...requestParams, search: searchValue};
            const response = await api.get(requestUrl, {params});
            let items;
            let next = null;

            if (paginated) {
                items = response.data.results;
                next = response.data.next;
            } else {
                items = response.data;
            }

            const mapped = mapItems(items);

            if (isNextPage) {
                setFetchedOptions((prev) => [...prev, ...mapped]);
            } else {
                setFetchedOptions(mapped);
            }
            setNextPage(next);
        } catch (error) {
            // silently fail
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    }, [url, requestParams, paginated, mapItems]);

    useEffect(() => {
        if (isRequest) {
            currentSearchRef.current = '';
            fetchData('');
        }
    }, [isRequest, fetchData]);

    useEffect(() => {
        if (isRequest && search !== undefined) {
            currentSearchRef.current = search;
            const timer = setTimeout(() => {
                fetchData(search);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [search, isRequest, fetchData]);

    const handleSearch = (value) => {
        if (isRequest) {
            setSearch(value);
        }
    };

    const handlePopupScroll = (e) => {
        if (!isRequest || !paginated || !nextPage || loadingMore) return;
        const {target} = e;
        if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 20) {
            fetchData(currentSearchRef.current, nextPage);
        }
    };

    const options = isRequest ? fetchedOptions : externalOptions;

    const filterOption = isRequest
        ? false
        : (input, option) => (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase());

    return (
        <StyledAntSelect
            showSearch={showSearch}
            filterOption={filterOption}
            onSearch={showSearch ? handleSearch : undefined}
            onPopupScroll={handlePopupScroll}
            loading={loading || loadingMore}
            options={options}
            {...props}
        />
    );
}
